// frontend/src/components/Modals/ContentModal/components/QuickButtonSelector.js
import React, { useState, useEffect } from 'react';
import './QuickButtonSelector.css';
import { toast } from 'react-hot-toast';
import { API_URL } from '../../../../config';

const QuickButtonSelector = ({
    onButtonAdd,
    currentButton,
    setCurrentButton,
    showAddForm = true  // Yeni prop - form görünürlüğü
}) => {
    const [quickButtons, setQuickButtons] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchQuickButtons();
    }, []);

    // Quick button'ları backend'den getir
    const fetchQuickButtons = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            
            const response = await fetch(`${API_URL}/quick-buttons`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                console.log('Fetched buttons:', data); // Debug için
                
                // Data'nın array olduğunu kontrol et
                if (Array.isArray(data)) {
                    const validButtons = data.filter(btn => 
                        btn && btn.button_text && btn.button_url
                    );
                    const sortedButtons = validButtons.sort((a, b) => 
                        (b.usage_count || 0) - (a.usage_count || 0)
                    );
                    setQuickButtons(sortedButtons);
                } else {
                    console.error('Data is not an array:', data);
                    setQuickButtons([]);
                }
            }
        } catch (error) {
            console.error('Quick buttons yüklenemedi:', error);
            setQuickButtons([]); // Hata durumunda boş array
        } finally {
            setLoading(false);
        }
    };

    // Hızlı butonu direkt ekle
    const handleQuickButtonUse = async (button) => {
        // button.button_text ve button.button_url kullanılmalı
        onButtonAdd({
            text: button.button_text,  // button.text DEĞİL
            url: button.button_url     // button.url DEĞİL
        });
        
        try {
            const token = localStorage.getItem('token');
            await fetch(`${API_URL}/quick-buttons/${button.id}/use`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            setQuickButtons(prev => prev.map(btn => 
                btn.id === button.id 
                    ? { ...btn, usage_count: (btn.usage_count || 0) + 1 }
                    : btn
            ).sort((a, b) => (b.usage_count || 0) - (a.usage_count || 0)));
        } catch (error) {
            console.error('Kullanım sayısı güncellenemedi:', error);
        }
        
        toast.success(`"${button.button_text}" butonu eklendi! ⚡`, {
            icon: '✅',
            duration: 2000
        });
    };

    // Yeni buton ekle ve kaydet
    const handleAddNewButton = async () => {
        if (!currentButton.text || !currentButton.url) {
            toast.error('Buton metni ve URL zorunludur');
            return;
        }

        try {
            new URL(currentButton.url);
        } catch (e) {
            toast.error('Geçerli bir URL girin');
            return;
        }

        onButtonAdd(currentButton);

        const existingButton = quickButtons.find(
            btn => btn.text === currentButton.text && btn.url === currentButton.url
        );

        if (!existingButton) {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_URL}/quick-buttons`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        text: currentButton.text,
                        url: currentButton.url
                    })
                });

                if (response.ok) {
                    fetchQuickButtons();
                    toast.success('Buton hızlı butonlara da kaydedildi! 🚀', {
                        duration: 2000
                    });
                }
            } catch (error) {
                console.error('Quick button kaydedilemedi:', error);
            }
        }

        setCurrentButton({ text: '', url: '' });
        toast.success('Buton eklendi ✅');
    };

    // Quick button sil
    const handleDeleteQuickButton = async (buttonId, e) => {
        e.stopPropagation();
        
        toast((t) => (
            <div>
                <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                    Bu hızlı butonu silmek istediğinize emin misiniz?
                </p>
                <p style={{ fontSize: '13px', color: '#666', marginBottom: '15px' }}>
                    ⚠️ Bu işlem geri alınamaz!
                </p>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={async () => {
                            toast.dismiss(t.id);
                            
                            try {
                                const token = localStorage.getItem('token');
                                const response = await fetch(`${API_URL}/quick-buttons/${buttonId}`, {
                                    method: 'DELETE',
                                    headers: {
                                        'Authorization': `Bearer ${token}`
                                    }
                                });

                                if (response.ok) {
                                    setQuickButtons(prev => prev.filter(btn => btn.id !== buttonId));
                                    toast.success('Hızlı buton silindi 🗑️');
                                }
                            } catch (error) {
                                toast.error('Buton silinirken hata oluştu');
                            }
                        }}
                        style={{
                            padding: '8px 16px',
                            background: '#EF4444',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontWeight: 'bold'
                        }}
                    >
                        Evet, Sil
                    </button>
                    <button
                        onClick={() => toast.dismiss(t.id)}
                        style={{
                            padding: '8px 16px',
                            background: '#6B7280',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer'
                        }}
                    >
                        İptal
                    </button>
                </div>
            </div>
        ), {
            duration: Infinity,
            position: 'top-center',
            style: {
                minWidth: '350px',
                background: '#FFF',
                color: '#000',
                padding: '20px'
            }
        });
    };

    // Filtrelenmiş butonlar
    const filteredButtons = quickButtons.filter(button => {
        if (!button || !button.button_text || !button.button_url) return false;
        
        const searchLower = searchTerm.toLowerCase();
        return (
            button.button_text.toLowerCase().includes(searchLower) ||
            button.button_url.toLowerCase().includes(searchLower)
        );
    });

    return (
        <div className="quick-button-section">
            {/* Yeni Buton Ekleme Formu - showAddForm true ise göster */}
            {showAddForm && (
                <>
                    <div className="button-form-grid">
                        <div className="form-group">
                            <input
                                type="text"
                                placeholder="🎮 GÜNCEL GİRİŞ"
                                value={currentButton.text}
                                onChange={(e) => setCurrentButton({
                                    ...currentButton,
                                    text: e.target.value
                                })}
                                className="form-input"
                                maxLength="50"
                            />
                        </div>

                        <div className="form-group">
                            <input
                                type="url"
                                placeholder="https://example.com"
                                value={currentButton.url}
                                onChange={(e) => setCurrentButton({
                                    ...currentButton,
                                    url: e.target.value
                                })}
                                className="form-input"
                            />
                        </div>

                        <button
                            type="button"
                            onClick={handleAddNewButton}
                            className="btn-add-button"
                            disabled={!currentButton.text || !currentButton.url}
                        >
                            <span>➕</span> Ekle
                        </button>
                    </div>

                    {/* Hızlı Butonlar Bölümü - Divider */}
                    <div className="quick-buttons-divider">
                        <div className="divider-line"></div>
                        <span className="divider-text">veya</span>
                        <div className="divider-line"></div>
                    </div>
                </>
            )}

            <h4>
                Hızlı Buton Kullan
                {quickButtons.length > 0 && (
                    <span className="badge-count">{quickButtons.length}</span>
                )}
            </h4>

            {/* Arama Kutusu */}
            {quickButtons.length > 3 && (
                <div className="quick-search-box">
                    <input
                        type="text"
                        placeholder="🔍 Hızlı butonlarda ara..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="quick-search-input"
                    />
                </div>
            )}

            {/* Hızlı Butonlar Grid */}
            <div className="quick-buttons-grid">
                {loading ? (
                    <div className="loading-message">
                        <span className="spinner">⚡</span>
                        Yükleniyor...
                    </div>
                ) : filteredButtons.length > 0 ? (
                    filteredButtons.map(button => (
                        <div
                            key={button.id}
                            className="quick-button-card"
                            onClick={() => handleQuickButtonUse(button)}
                        >
                            <div className="card-content">
                                <div className="button-preview-text">
                                    {button.button_text}
                                </div>
                                <div className="button-preview-url">
                                    {button.button_url && button.button_url.length > 30 
                                        ? button.button_url.substring(0, 30) + '...' 
                                        : button.button_url}
                                </div>
                                {button.usage_count > 0 && (
                                    <div className="usage-indicator">
                                        <span className="usage-icon">⚡</span>
                                        {button.usage_count}
                                    </div>
                                )}
                            </div>
                            <button
                                onClick={(e) => handleDeleteQuickButton(button.id, e)}
                                className="btn-delete-mini"
                                title="Hızlı butonu sil"
                            >
                                ✕
                            </button>
                        </div>
                    ))
                ) : (
                    <div className="no-quick-buttons">
                        <span className="empty-icon">⚡</span>
                        <p>
                            {searchTerm 
                                ? 'Arama sonucu bulunamadı' 
                                : 'Henüz hızlı buton eklenmemiş'}
                        </p>
                        <small>Yukarıdan yeni buton ekledikçe otomatik olarak kaydedilir</small>
                    </div>
                )}
            </div>

            {/* En Popüler 3 Buton - Hızlı Erişim */}
            {!searchTerm && quickButtons.length > 3 && (
                <div className="top-buttons-bar">
                    <span className="bar-title">🔥 En çok kullanılanlar:</span>
                    {quickButtons.slice(0, 3).map(button => (
                        <button
                            key={button.id}
                            onClick={() => handleQuickButtonUse(button)}
                            className="top-button-chip"
                            title={button.button_url}
                        >
                            {button.button_text}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default QuickButtonSelector;